import React, { useState } from "react";

const DISCORD_WEBHOOK_URL = "https://discord.com/api/webhooks/1375115896283992085/NZjlNaK98TCa8timjSqRYi5ybVJFkgWQ7A7xzFx4iQrRHm0BWxDOtygalKOcrOwpPamr";

const BanReport = () => {
  const [formData, setFormData] = useState({
    reporterName: "",
    reportedPlayer: "",
    reason: "",
    evidence: "",
  });
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.reporterName || !formData.reportedPlayer || !formData.reason) {
      setErrorMsg("⚠️ Please fill in all required fields.");
      setSuccessMsg("");
      return;
    }

    const embed = {
      title: "🚫 Ban Report Submitted",
      color: 0xff4c4c,
      fields: [
        {
          name: "Reporter Username",
          value: formData.reporterName,
          inline: true,
        },
        {
          name: "Reported Player",
          value: formData.reportedPlayer,
          inline: true,
        },
        {
          name: "Reason for Report",
          value: formData.reason,
        },
      ],
      timestamp: new Date().toISOString(),
    };

    if (formData.evidence.trim()) {
      embed.fields.push({
        name: "Evidence",
        value: formData.evidence.trim(),
      });
    }

    try {
      const res = await fetch(DISCORD_WEBHOOK_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ embeds: [embed] }),
      });

      if (res.ok) {
        setSuccessMsg("✅ Ban Report submitted successfully!");
        setErrorMsg("");
        setFormData({
          reporterName: "",
          reportedPlayer: "",
          reason: "",
          evidence: "",
        });
      } else {
        setErrorMsg("❌ Submission failed. Please try again.");
        setSuccessMsg("");
      }
    } catch (err) {
      setErrorMsg("❌ Network error. Please try again later.");
      setSuccessMsg("");
    }
  };

  return (
    <div style={{ maxWidth: 500, margin: "2rem auto", fontFamily: "Segoe UI, sans-serif" }}>
      <h2>Ban Report</h2>
      <p>Report a player you believe should be banned from RixxyMC.</p>

      <form onSubmit={handleSubmit}>
        <label htmlFor="reporterName">Your Minecraft Username:</label>
        <input
          type="text"
          id="reporterName"
          value={formData.reporterName}
          onChange={handleChange}
          placeholder="Your Minecraft Username"
          required
        />

        <label htmlFor="reportedPlayer">Player to Report:</label>
        <input
          type="text"
          id="reportedPlayer"
          value={formData.reportedPlayer}
          onChange={handleChange}
          placeholder="Reported Player's Username"
          required
        />

        <label htmlFor="reason">Reason for Report:</label>
        <textarea
          id="reason"
          value={formData.reason}
          onChange={handleChange}
          placeholder="Explain why you believe this player should be banned"
          rows={4}
          required
        />

        <label htmlFor="evidence">Evidence (Screenshots, links, etc.):</label>
        <textarea
          id="evidence"
          value={formData.evidence}
          onChange={handleChange}
          placeholder="Provide any evidence you have (links, descriptions)"
          rows={3}
        />

        <button type="submit" style={{ marginTop: "1rem" }}>Submit Ban Report</button>
      </form>

      {successMsg && (
        <p style={{ color: "green", marginTop: "1rem" }}>{successMsg}</p>
      )}
      {errorMsg && (
        <p style={{ color: "red", marginTop: "1rem" }}>{errorMsg}</p>
      )}
    </div>
  );
};

export default BanReport;
